<template>
  <div class="callback">
    <div class="loading-message">
      Autenticando...
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'

export default {
  name: 'Callback',
  setup() {
    const router = useRouter()

    onMounted(async () => {
      const urlParams = new URLSearchParams(window.location.search)
      const code = urlParams.get('code')
      const returnUrl = urlParams.get('return_url') || '/iframe' // Adicionado fallback para /iframe

      console.log("code", code);

      if (code) {
        try {
          const response = await axios.post('https://br2ht4cf5a.execute-api.sa-east-1.amazonaws.com/dev/pipedrive/auth',
            {
              grant_type: 'authorization_code',
              authorization_code: code,
              client_id: process.env.VUE_APP_PIPEDRIVE_CLIENT_ID,
              client_secret: process.env.VUE_APP_PIPEDRIVE_CLIENT_SECRET,
              redirect_uri: process.env.VUE_APP_REDIRECT_URI
            }
          )

          localStorage.setItem('pipedrive_token', response.data.data.access_token)
          console.log('Token armazenado:', response.data.data.access_token)
          router.push(returnUrl)
        } catch (error) {
          console.error('Erro na autenticação:', error)
          router.push('/')
        }
      }
    })
  }
}
</script>